import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PromoteModeratorModal from '../../components/promote-moderator-modal';
import { closeModal } from '../../actions/close-modal';
import { getUserById } from '../../selectors/user-selectors';
import { getUserById as getMemberById } from '../../selectors/search-selectors';

const mapStateToProps = (state, ownProps) => ({
  user: getUserById(state, ownProps.userId) || getMemberById(state, ownProps.userId),
});

const mapDispatchToProps = (dispatch, ownProps) =>
  bindActionCreators(
    {
      closeModal,
      promoteModerator: () => closeModal(ownProps.userId),
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(PromoteModeratorModal);



// WEBPACK FOOTER //
// ./app/containers/promote-moderator-modal/promote-moderator-modal.js